<template>
  <div>
    <v-card color="grey lighten-3" light>
      <!-- <v-container> -->
      <v-card-text>
      <v-timeline align-top dense>
        <v-timeline-item color="blue-grey">
          <template v-slot:icon>
            <v-icon small dark>mdi-folder-open</v-icon>
          </template>
          <expediente-component :loading="loading" :soloLectura="soloLectura" :idOficio="idOficio"/>
        </v-timeline-item>
        <v-timeline-item color="blue-grey">
          <template v-slot:icon>
            <v-icon small dark>mdi-file-document-outline</v-icon>
          </template>
          <oficio-entrante-timeline
            v-if="tipoOficio == 'entrante'"
            :idOficio="idOficio"
            :esPadre="true"
            :soloLectura="soloLectura"
            @oficioCargado="oficioCargado"
            @setSoloLectura="setSoloLectura"
            @oficioEliminado="oficioEliminado"
            @nuevoLog="obtenerLogs"
          />
          <oficio-generado-timeline
            v-if="tipoOficio == 'generado'"
            :idOficio="idOficio"
            :esPadre="true"
            :soloLectura="soloLectura"
            @oficioCargado="oficioCargado"
            @setSoloLectura="setSoloLectura"
            @oficioEliminado="oficioEliminado"
            @nuevoLog="obtenerLogs"
          />
        </v-timeline-item>

        <!-- Mostrar documentos -->
        <v-timeline-item
          color="blue-grey"
          v-for="(historico, index) in historicoOficio"
          :key="`A-${index}`"
        >
            <template v-slot:icon>
              <v-icon small dark>mdi-file-document-outline</v-icon>
            </template>

            <!-- SI ES UN OFICIO -->
            <oficio-entrante-timeline
              v-if="historico.oficio.entrante"
              :idOficio="historico.oficio.entrante._id"
              :soloLectura="soloLectura"
              :esPadre="false"
              @oficioRemovido="oficioRemovido"
              @oficioEliminado="oficioEliminado"
              @nuevoLog="obtenerLogs"
            />
            <oficio-generado-timeline
              v-if="historico.oficio.generado"
              :idOficio="historico.oficio.generado._id"
              :soloLectura="soloLectura"
              :esPadre="false"
              @oficioRemovido="oficioRemovido"
              @oficioEliminado="oficioEliminado"
              @nuevoLog="obtenerLogs"
            />
        </v-timeline-item>
        <!-- Mostrar documentos -->

        <!-- Botón -->
        <v-timeline-item color="blue-grey">
          <template v-slot:icon>
            <v-icon small dark>mdi-plus-thick</v-icon>
          </template>
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="blue-grey" dark v-on="on" small
                >Agregar contenido</v-btn
              >
            </template>
            <v-list>
              <v-list-item
                v-if="!soloLectura"
                @click="agregarEntrante = true"
              >
                <v-list-item-title>Nuevo oficio entrante</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!soloLectura"
                @click="agregarGenerado = true"
              >
                <v-list-item-title>Generar nuevo oficio</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!soloLectura" @click="relacionar = true">
                <v-list-item-title
                  >Agregar oficio existente</v-list-item-title
                >
              </v-list-item>
              <v-list-item @click="agregarComentario = true">
                <v-list-item-title>Agregar comentario</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="historicoOficio.length > 1 && !soloLectura" @click="cambiarOrden = true">
                <v-list-item-title>Cambiar orden oficio</v-list-item-title>
              </v-list-item>
          <!-- <v-list-item v-if="!soloLectura">
                <v-list-item-title>Agregar dictamen</v-list-item-title>
                </v-list-item> -->
            </v-list>
          </v-menu>
        </v-timeline-item>
        <v-timeline-item color="blue-grey">
          <template v-slot:icon>
            <v-icon small dark>
              mdi-message-processing-outline
            </v-icon>
          </template>
          <v-card>
            <v-toolbar dense flat color="blue-grey lighten-5">
              <v-toolbar-title class="subtitle-1"
                >Comentarios</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="log">
              <span v-if="historicoComentario.length == 0">No se ha registrado actividad</span>
              <span v-else v-for="(historico, index) in historicoComentario" :key="`B-${index}`">
                {{ formatoFecha(historico.fecha) }} - {{ historico.comentario.usuario.titulo }}{{ historico.comentario.usuario.nombreCompleto }} - {{ historico.comentario.mensaje }}
                <br />
              </span>
            </v-card-text>
          </v-card>
        </v-timeline-item>
        
      </v-timeline>
      <!-- </v-container> -->
       <div style="padding:40px">
        <logs :logs="logs"></logs>
      </div>
      </v-card-text>
    </v-card>
     

    <nuevo-oficio-entrante
      v-if="agregarEntrante"
      :mostrar="agregarEntrante"
      :relacionado="{ id: idOficio, tipo: tipoOficio }"
      @cancelar="agregarEntrante = false"
      @oficioGuardado="oficioGuardado"
      @nuevoLog="obtenerLogs"
    />

    <nuevo-oficio-generado
      v-if="agregarGenerado"
      :mostrar="agregarGenerado"
      :relacionado="{ id: idOficio, tipo: tipoOficio }"
      @cancelar="agregarGenerado = false"
      @oficioGuardado="oficioGuardado"
      @nuevoLog="obtenerLogs"
    />

    <agregar-comentario
      v-if="agregarComentario"
      :mostrar="agregarComentario"
      :tipoOficio="tipoOficio"
      :idOficio="idOficio"
      @cancelar="agregarComentario = false"
      @comentarioAgregado="comentarioAgregado"
    />

    <relacionar-oficio
      v-if="relacionar"
      :mostrar="relacionar"
      :idPadre="idOficio"
      :tipoPadre="tipoOficio"
      :historicoId="historicoIds"
      @cancelar="relacionar = false"
      @oficioRelacionado="oficioRelacionado"
      @nuevoLog="obtenerLogs"
    />

    <cambiarOrdenOficiosComponent 
      v-if="cambiarOrden"
      :mostrar="cambiarOrden"
      @cancelar="cambiarOrden = false"
      @ordenModificado="ordenModificado"
    />
  </div>
</template>

<script>
// Librerías
import { mapGetters } from "vuex";
import { DateTime } from 'luxon';
//Componentes
import OficioEntranteTimeline from "../components/oficios/oficioEntranteTimeline";
import OficioGeneradoTimeline from "../components/oficios/oficioGeneradoTimeline";
import AgregarComentario from "../components/oficios/agregarComentario";
import RelacionarOficio from "../components/oficios/relacionarOficio";
import nuevoOficioEntrante from "../components/oficios/nuevoOficioEntrante";
import nuevoOficioGenerado from "../components/oficios/nuevoOficioGenerado";
import cambiarOrdenOficiosComponent from "../components/oficios/cambiarOrdenOficios.vue";
import ExpedienteComponent from "../components/expedientes/expediente.view.vue"
import Logs from "../components/logs/logs.vue"
import { getLogsOficio } from '../components/logs/logs.service'

export default {
  name: "consultarOficio",
  components: {
    OficioEntranteTimeline,
    OficioGeneradoTimeline,
    AgregarComentario,
    nuevoOficioEntrante,
    nuevoOficioGenerado,
    RelacionarOficio,
    cambiarOrdenOficiosComponent,
    ExpedienteComponent,
    Logs
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
  },
  watch: {
    $route(to, from) {
      this.idOficio = to.params.id;
      this.tipoOficio = to.params.tipo;

    },
    historico() {
      this.historicoIds = [];
      this.guardarHistoricosIds();
      this.generarHistoricos();
    },
  },
  data: () => ({
    loading: "false",
    search: null,
    idOficio: null,
    tipoOficio: null,
    historico: [],
    emisores: [],
    agregarComentario: false,
    agregarEntrante: false,
    agregarGenerado: false,
    relacionar: false,
    soloLectura: true,
    historicoIds: [],
    fecha: null,
    historicoComentario: [],
    historicoOficio: [],
    cambiarOrden: false,
    expediente:null,
    esPadre:false,
    logs:[]
  }),
  async created() {
    this.idOficio = this.$route.params.id;
    this.tipoOficio = this.$route.params.tipo;
    this.fecha = this.historico.fecha;
    if (this.tipoOficio !== 'entrante' && this.tipoOficio !== 'generado'){
        this.$router.replace('/oficios/Entrantes?page=1&search=&filter=0')
    }
    await this.obtenerLogs()
  },
  methods: {
    menuAction(action, id) {
      switch (action) {
        case "verPerfil":
          this.$router.push("/usuarios/perfil/" + id);
          break;
      }
      // console.log(action, id);
    },
    formatoFecha(fecha) {
      let dateTime = DateTime.fromISO(fecha);
      if(!dateTime.isValid) dateTime = DateTime.fromFormat(fecha, "yyyy-MM-dd TT");
      return dateTime.toFormat('dd/MM/yyyy HH:mm');
    },
    menuItems(path) {
      if (path)
        return [
          { text: "Consultar oficio", action: "verOficio" },
          { text: "Previsualizar oficio", action: "prevOficio" },
          { text: "Descargar oficio", action: "descargarOficio" },
        ];
      else return [{ text: "Consultar oficio", action: "verOficio" }];
    },
    setSoloLectura(soloLectura) {
      this.soloLectura = soloLectura;
    },
    oficioCargado(historico) {
      this.historico = historico;
    },
    oficioGuardado(historico) {
      // console.log(historico);
      this.historico.push(historico);
      this.agregarEntrante = false;
      this.agregarGenerado = false;
    },
    comentarioAgregado(comentario) {
      this.historico.push(comentario);
      this.agregarComentario = false;
    },
    oficioRemovido(id, comentario) {
      let index = this.historico.findIndex((x) => {
        if (x.oficio.entrante) if (x.oficio.entrante._id == id) return true;
        if (x.oficio.generado) if (x.oficio.generado._id == id) return true;
      });

      this.historico.splice(index, 1);
      this.historico.push(comentario);
    },
    oficioRelacionado(historico) {
      this.historico.push(historico);
      this.relacionar = false;
    },
    oficioEliminado(id) {
      if (this.idOficio == id) this.$router.go(-1);
      else {
        let index = this.historico.findIndex((x) => {
          if (x.oficio.entrante) if (x.oficio.entrante._id == id) return true;
          if (x.oficio.generado) if (x.oficio.generado._id == id) return true;
        });
        this.historico.splice(index, 1);
      }
    },
    guardarHistoricosIds() {
      this.historicoIds.push(this.idOficio);
      this.historico.findIndex((x) => {
        if (x.oficio.entrante) {
          this.historicoIds.push(x.oficio.entrante._id);
        }
        if (x.oficio.generado) {
          this.historicoIds.push(x.oficio.generado._id);
        }
      });
    },
    generarHistoricos(){
      this.historicoComentario = [];
      this.historicoOficio = [];
      this.historico.forEach((x) => {
        if(x.comentario.usuario) this.historicoComentario.unshift(x)
        else this.historicoOficio.push(x);
      });
    },
    ordenModificado(historico){
      this.historico = historico;
      this.cambiarOrden = false;
    },
    async obtenerLogs(){
      try{
          this.loading=true;
          const serverResponse = await getLogsOficio(this.tipoOficio, this.idOficio)
          this.loading=false;
          if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
          this.logs= serverResponse.logs

      }catch(error){
          this.loading=false
          this.$notificarError(error);
      }
    },
    // nuevoLog(log){
    //   this.logs.unshift(log)
    // }
  },
};
</script>

<style>

.log {
  background-color: #fff;
  max-height: 250px;
  overflow: scroll;
}

</style>
